import React from 'react'
import './PlayerTimer.css'

class PlayerTimer extends React.Component {
  
  renderLives = (style) => {
    if (style === 'full') {
      return [...Array(this.props.lives)].map((el, index) => {

        return <i className="fas fa-heart" key={index}></i>
      })
    } else {
      const { lives, startLives } = this.props
      return [...Array(startLives - lives)].map((el, index) => {
        return <i className="far fa-heart" key={index}></i>
      })
    }
  }
  
  renderLivesBar = () => {
    const { player } = this.props
    if (this.props.startLives <= 8) {
      return (
        <div className="loose-score">
          {this.renderLives(`${player === 0 ? 'empty' : 'full'}`)}
          {this.renderLives(`${player === 1 ? 'empty' : 'full'}`)}
        </div>
      )
    } else {
      return (
        <div className="loose-score">
          <span style={{fontSize: 'xx-large'}}>{this.props.lives}</span> <i className="fas fa-heart"></i>
        </div>
      )
    }
  }

  renderTimer = () => {
    return (
      <div className={`timer ${this.props.active ? 'active' : ''}`}>
        {this.props.active ? this.props.time : ''}
      </div>
    )
  }

  render() {
    return(
      <>
        {this.props.player === 0 ? this.renderTimer() :
        this.renderLivesBar()}
        {this.props.player === 1 ? this.renderTimer() :
        this.renderLivesBar()}
      </>
    )
  }
}

export default PlayerTimer